import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpBetWin implements ICommand
{

	public GameID : number = 0;
	public SignedSignal : number = 0;
	public WinAmount : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.GameID = ba.readInt53();
		this.SignedSignal = ba.readUint8();
		this.WinAmount = ba.readInt53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.GameID);
		ba.writeUint8(this.SignedSignal);
		ba.writeUint53(this.WinAmount);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpBetWin();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'SignedSignal(B)='+this.SignedSignal+' ';
		str += 'WinAmount(Q)='+this.WinAmount+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50004;
	}

	public getCmdName() : string
	{
		return 'SpBetWin';
	}

}
